import actions from "./actions";

const reducers = {
  [actions.sendForgetPassword.request]: (state, action) => {
    state.loading = true;
  },
  [actions.sendForgetPassword.success]: (state, action) => {
    state.loading = false;
  },
  [actions.sendForgetPassword.failure]: (state, action) => {
    state.loading = false;
    state.errors = action.payload || { message: "there was an error" };
  },
};

export default reducers;
